export default __webpack_public_path__ + "static/media/q2_step4.a58233b5.png";